import { atom } from "recoil";

export const STATUS_TIMEOUT = 800;

export const ACTIVE_STATE = "clickToCallActiveState";

export const CALLER_TYPES = {
  AGENT: "AGENT",
  USER: "USER",
};

export const CALL_STATUS_TYPES = {
  INITIATED: "INITIATED",
  RINGING: "RINGING",
  REJECTED: "REJECTED",
  MISSED: "MISSED",
  ANSWERED: "ANSWERED",
  ENDED: "ENDED",
  NETWORK_ERROR: "NETWORK_ERROR",
  BUSY: "BUSY"
};

export const ACTIVE_STATE_TYPES = {
  DISMISSED: "DISMISSED",
  UPDATE: "UPDATE",
  CALL_MAXIMIZED: "CALL_MAXIMIZED",
  CALL_MINIMIZED: "CALL_MINIMIZED",
  ERROR: "ERROR",
};

export const VIEW_MESSAGES = {
  [ACTIVE_STATE_TYPES.CALL_MAXIMIZED]: {
    [`${CALL_STATUS_TYPES.INITIATED}`]: "Please wait while we connect with <agentName>, your <agentContactType>",

    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.NETWORK_ERROR}`]:
      "Sorry, we are unable to connect to <agentName>. Please try again later.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.REJECTED}`]: "It looks like <agentName> is busy. We have notified <agentName> to call you back",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.MISSED}`]: "It looks like <agentName> is unavailable. We have notified <agentName> to call you back",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.BUSY}`]: "Sorry we were unable to connect with <agentFirstName>. We have notified <agentFirstName> to call you back.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.RINGING}`]: "Please wait while we connect with <agentName>, your <agentContactType>.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.ENDED}`]: "It looks like <agentName> has ended the call.",

    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.INITIATED}`]: "<agentFirstName> is connected. Now we are connecting you. When you get a call from <callerId>, please answer it.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.REJECTED}`]: "We tried calling you but looks like you are busy.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.MISSED}`]: "We tried calling you but there was no response.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.BUSY}`]: "Sorry we were unable to connect to you.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.RINGING}`]: "<agentFirstName> is connected. Now we are connecting you. When you get a call from <callerId>, please answer it.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.ANSWERED}`]: "Call is in progress",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.NETWORK_ERROR}`]: "Sorry, we are unable to connect to you.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.ENDED}`]: "You ended the call.",

    [`${CALL_STATUS_TYPES.ENDED}`]: "Your call with <agentName> has ended.",
  },
  [ACTIVE_STATE_TYPES.CALL_MINIMIZED]: {
    [`${CALL_STATUS_TYPES.INITIATED}`]: "Connecting to <agentName>.",

    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.NETWORK_ERROR}`]: "Unable to connect to <agentName>.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.REJECTED}`]: "<agentName> is busy.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.MISSED}`]: "<agentName> is unavailable.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.BUSY}`]: "<agentName> is busy.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.RINGING}`]: "Connecting to <agentName>.",
    [`${CALLER_TYPES.AGENT}_${CALL_STATUS_TYPES.ENDED}`]: "<agentName> has ended the call.",

    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.INITIATED}`]: "Connecting you, please answer it.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.REJECTED}`]: "It looks like you are busy.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.MISSED}`]: "It looks like you are unavailable.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.BUSY}`]: "It looks like you are busy.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.RINGING}`]: "Connecting you, please answer it.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.ANSWERED}`]: "Call is in progress",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.NETWORK_ERROR}`]: "Sorry, we are unable to connect to you.",
    [`${CALLER_TYPES.USER}_${CALL_STATUS_TYPES.ENDED}`]: "You ended the call.",

    [`${CALL_STATUS_TYPES.ENDED}`]: "Call ended.",
  },
};

export const VALIDATION_MSGS = {
  REQUIRED: "This field is required",
  INVALID_CONTACT_NUMBER: "Invalid Number"
};

export const ERROR_MSGS = {
  TITLE: "Sorry, we could not place your call at this time",
  MESSAGE: "Please try again later"
};

export const CONTACT_NUMBER_VALIDATION = /^(\s*|\d+)$/;

export const INITIAL_STATE = {
  activeCall: null,
  activeState: null,
  callDetails: null,
  error: null,
  agentNumber: null,
  agentName: null,
  agentContactType: null,
  userNumber: null,
  userName: null,
};

export const clickToCallAtom = atom({
  key: "clickToCall",
  default: INITIAL_STATE,
})
